module.exports = require("@nestjs/core");